<div class="container">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <div id="accordion" class="application-form additional-details">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    </div>    
</div>